export class AgentReportScope {
  static READ_ORDER = 'READ_ORDER';
}
